<script>
  export let data
  export let blocksConfig
  export let loggedIn
  let disabled_msg = false

  function addBlock(cat, type, fields) {
    let myFields = fields.split(',')

    // remove the current header
    if (cat == 'headers') {
      data.entries = data.entries.filter(function(e) {
        return e.layout !== 'header1'
      })
      data.entries = data.entries.filter(function(e) {
        return e.layout !== 'header2'
      })
      data.entries = data.entries.filter(function(e) {
        return e.layout !== 'header3'
      })
    }

    var myArray = [
      '<p>Lorem ipsum dolor site amet, consectetur adipiscing elit. Sed id pretium erat. Donec interdum risus at ligula cursus.</p>',
      '<p>Cras site amet ante a lacinia. Curabitur eget eros eget neque pulvinar egestas. Mauris et facilisis massa.</p>',
      '<p>Vestibulum maximus at erat vel scelerisque. Mauris eu sapien sit amet nunc fermentum placerat mattis vitae felis.</p>',
      '<p>Aliquam risus sem, tempor ac sapien ut, congue mattis erat. Aenean id risus semper, ornare nisi ut.</p>',
      '<p>Etiam semper porttitor mauris vel luctus. Nunc venenatis est vitae turpis elementum.</p>',
      '<p>Maecenas varius malesuada urna, vel condimentum neque gravida quis. Suspendisse potenti.</p>',
    ]
    var randomLorem = myArray[Math.floor(Math.random() * myArray.length)]

    let newId = Math.random()
      .toString(36)
      .substr(2, 9)
    console.log(newId)

    let newItem = {
      id: newId,
      layout: type,
      title: '',
      tagline: '',
      body: randomLorem,
      extended: randomLorem,
      images: [],
      flip: false,
      color: '',
      cat: cat,
      fields: myFields,
    }
    data.entries.unshift(newItem)
    data = data
    console.log(data)

    closeBlocks()

    localStorage.setItem('json', JSON.stringify(data))

    //document.getElementById('save').click()

    if (cat == 'headers') {
      let element = document.querySelector('header')
      element.scrollIntoView()
    } else {
      let element = document.querySelector('main')
      element.scrollIntoView()
    }
  }

  function closeBlocks() {
    document.querySelector('#blocks').style.display = 'none'
  }

  /*
  function chooseHeader(type) {
    data.header.layout = type
    data = data
    localStorage.setItem('json', JSON.stringify(data))
    console.log(data)
    closeBlocks()
  }
  */

  function disabled() {
    disabled_msg = true
    window.setTimeout(function() {
      disabled_msg = false
    }, 2000)
  }
</script>

<div class="close" on:click={closeBlocks}>&times;</div>

<div class="clear" style="height: 14px;" />

{#each blocksConfig.blocks as block}
  {#if block.cat == 'headers'}
    <div
      class="box {block.cat}"
      on:click={() => addBlock(block.cat, block.name, block.fields)}>
      <img
        class="img-fluid"
        src="themes/PlayFair/preview/{block.name}.jpg"
        alt="preview" />
      <div class="name">{block.name}</div>
    </div>

  {:else if block.cat == 'galleries' && !loggedIn}
    <div
      class="box {block.cat}"
      style="cursor: not-allowed;"
      on:click={disabled}>
      <img
        class="img-fluid"
        src="themes/PlayFair/preview/{block.name}.jpg"
        alt="preview" />
      <div class="name">
        {#if disabled_msg}
          Create an account to use this feature
        {:else}
          {block.name}
          <span class="badge badge-success float-right">PRO</span>
        {/if}
      </div>
    </div>

  {:else}
    <div
      class="box {block.cat}"
      on:click={() => addBlock(block.cat, block.name, block.fields)}>
      <img
        class="img-fluid"
        src="themes/PlayFair/preview/{block.name}.jpg"
        alt="preview" />
      <div class="name">{block.name}</div>
    </div>
  {/if}

{/each}

<style>
  .box {
    margin-bottom: 10px;
    border: 1px solid #ddd;
    display: block;
    background-color: white;
    cursor: pointer;
    color: black;
    text-decoration: none;
  }

  .box .name {
    padding: 10px;
    border-top: 1px solid #ddd;
    font-size: 15px;
  }

  label:first-child {
    margin-top: 0;
  }

  .clear {
    clear: both;
    height: 10px;
  }

  .close {
    cursor: pointer;
  }

  .disabled {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }
</style>
